let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2JjU5")).then(() => parcelRequire('jocNS'));